/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/${payload.jenis}/laporan${payload.tipe ? `-${payload.tipe}` : ''}?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async transaksi({}, payload) {
    const url = `/${payload.jenis}?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  download({}, payload) {
    const url = process.env.VUE_APP_API_URL + `/${payload.jenis}/${payload.url}?${queryString(payload.params)}`;
    return url;
  },

  detail({}, payload) {
    const url = `/${payload.jenis}/${payload.id}`;
    return http.get(url).then(({ data }) => data);
  },
};
